<template>
    <div class="modal" id="confirmationRestartModal" tabindex="-1" role="dialog" aria-labelledby="confirmationRestartModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">Restart</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" @click="onClose">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    If you restart the import process, changes will be lost. Do you really want to restart the process?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="onConfirm">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

	import 'bootstrap-vue/dist/bootstrap-vue.css';

    export default {
    	props: ['id'],
        data() {
            return {}
        },
        methods: {
            onClose() {
				$('#confirmationRestartModal').modal('toggle');
            },
            onConfirm() {
				window.location = '/?reset-import=' + this.id;
            },
            onCancel() {
				$('#confirmationRestartModal').modal('toggle');
            }
        }
    }
</script>